import React from 'react';
import { useSelector } from 'react-redux';
import GeneralPane from './Tabs/GeneralPane';
import ProductionPane from './Tabs/ProductionPane';

const ConfiguratorBase = () => {
  const selectedTab = useSelector((state) => state.configurator.selectedTab),
        id = useSelector((state) => state.configurator.id);

  return (
    <div className='configurator-base'>
      {selectedTab === 1 && <GeneralPane />}
      {selectedTab === 2 && <ProductionPane />}

      <style>
         {`[data-itemid='${id}'] { box-shadow: 0 0 3px #404040; position: relative; z-index: 2; }`}
      </style>
    </div>
  );
};

export default ConfiguratorBase;
